export const LOAD_SMS_REQUEST = 'LOAD_SMS_REQUEST';
export const LOAD_SMS_SUCCESS = 'LOAD_SMS_SUCCESS';
export const LOAD_SMS_FAIL = 'LOAD_SMS_FAIL';

export const LOAD_TEMPLATES_REQUEST = 'LOAD_TEMPLATES_REQUEST';
export const LOAD_TEMPLATES_SUCCESS = 'LOAD_TEMPLATES_SUCCESS';
export const LOAD_TEMPLATES_FAIL = 'LOAD_TEMPLATES_FAIL';
